module.exports = window.fs;